export const orders = [
  {
    id: 'order-1',
    orderRef: 'MS-2025-001',
    userId: 'user-2',
    productId: 'prod-1',
    planId: 'plan-1b',
    productName: 'Motion Grid Pro',
    planName: 'Agency',
    amount: 79,
    currency: 'USD',
    status: 'paid' as const,
    createdAt: '2025-03-10',
    paidAt: '2025-03-10',
  },
  {
    id: 'order-2',
    orderRef: 'MS-2025-002',
    userId: 'user-2',
    productId: 'prod-4',
    planId: 'plan-4a',
    productName: 'Elementor Starter Kit',
    planName: 'Starter',
    amount: 39,
    currency: 'USD',
    status: 'paid' as const,
    createdAt: '2025-03-15',
    paidAt: '2025-03-15',
  },
  {
    id: 'order-3',
    orderRef: 'MS-2025-003',
    userId: 'user-3',
    productId: 'prod-2',
    planId: 'plan-2b',
    productName: 'Loop Grid Filters',
    planName: 'Multi',
    amount: 49,
    currency: 'USD',
    status: 'paid' as const,
    createdAt: '2025-04-01',
    paidAt: '2025-04-01',
  },
  {
    id: 'order-4',
    orderRef: 'MS-2025-004',
    userId: 'user-3',
    productId: 'prod-6',
    planId: 'plan-6a',
    productName: 'Ecommerce Template Pack',
    planName: 'Store',
    amount: 59,
    currency: 'USD',
    status: 'pending' as const,
    createdAt: '2025-04-20',
    paidAt: null,
  },
  {
    id: 'order-5',
    orderRef: 'MS-2025-005',
    userId: 'user-4',
    productId: 'prod-7',
    planId: 'plan-7a',
    productName: 'Motion Icon Library',
    planName: 'Standard',
    amount: 19,
    currency: 'USD',
    status: 'paid' as const,
    createdAt: '2025-04-05',
    paidAt: '2025-04-05',
  },
  {
    id: 'order-6',
    orderRef: 'MS-2025-006',
    userId: 'user-5',
    productId: 'prod-3',
    planId: 'plan-3a',
    productName: 'Motion Portfolio Theme',
    planName: 'Standard',
    amount: 49,
    currency: 'USD',
    status: 'paid' as const,
    createdAt: '2025-04-12',
    paidAt: '2025-04-12',
  },
];